import StateInterface from "../state-interface";

export const login_flow_global_state: StateInterface["login_flow_global_state"] = {
	stage: {
		id: 0,
		name: "phone",
		trigger_source: "default_redux_state",
	},
	action: {
		callback_url: "https://beegru.com/en-IN/",
		// sign_in: (session: any) => {},
		// sign_up: (session: any) => {},
		// sign_out: () => {},
		sign_in: ["session", "return"],
		sign_up: ["session", "return"],
		sign_out: ["return"],
	},
	user: {
		user_id: "",
		country_code: "+91",
		phone: "",
		is_sign_up: false,
		is_sign_in: false,
		is_signed_in: false,
		has_referral_code: false,
		referral_code: "",
		otp: "",
		first_name: "",
		last_name: "",
		display_name: "",
	},
	referrer: {
		referrer_type: "user",
		referrer_id: "",
		country_code: "+91",
		phone: "",
		first_name: "",
		last_name: "",
		display_name: "",
	},
	ui: {
		type: "modal",
		// type: "redirect",
		modal: {
			open: false,
		},
		snackbar: {
			open: false,
			message: "",
			type: "info",
		},
	},
};
